<template>
    <div id="phone">
        <div class="box">
            <span>{{msg}}</span>
            <span>{{url}}</span>
        </div>
    </div>
</template>

<script>
export default {
  name: 'phone',
  data () {
    return {
      msg:"",
      url:''
    }
  },

  mounted () {
        var sUserAgent = navigator.userAgent.toLowerCase();
        var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
        var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
        var bIsMidp = sUserAgent.match(/midp/i) == "midp";
        var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
        var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
        var bIsAndroid = sUserAgent.match(/android/i) == "android";
        var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
        var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
        // if (!(bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) ){
        //     this.$router.push({ path:'/join'})
        // } else {
        //     this.$router.push({ path:'/phone'})
        // }
      let lang = localStorage.getItem("language")
    if(lang == 'en'){
      this.msg = "Please use a desktop or a laptop computer to access the Coding Olympics:"
    //   this.url = 'https://zone.codingolympics.cn/#/?lang=en'
    let url = process.env.GAME_INDEX_URL
    this.url = url
    }else if(lang == 'zh'){
        this.msg = "如需浏览，请使用电脑端浏览器访问："
        let url = process.env.GAME_INDEX_URL
        this.url = url
    }else if(lang == 'fr'){
        this.msg = "Merci d’utiliser un ordinateur ou un ordinateur portable pour avoir accès aux Jeux Olympiques de Codage:"
        this.url = 'https://zone.codingolympics.cn/#/?lang=fr'
    }else if(lang == 'sp'){
        this.msg = "Favor de utilizar una computadora o una laptop para tener acceso a las Olimpiadas de Coding:"
        this.url = 'https://zone.codingolympics.cn/#/?lang=sp'
    }else{
        this.msg = "如需浏览，请使用电脑端浏览器访问："
        let url = process.env.GAME_INDEX_URL
        this.url = url
    }
    
  },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped rel="stylesheet/scss" lang="scss">
#phone{
    height: 100%;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background: rgba(0,0,0,.3);
    z-index: 999;
}
.box{
    width: 88%;
    height: 240px;
    background: #fff;
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translateX(-50%);
    text-align: left;
    font-size: 30px;
    color: #666;
    border-radius: 10px;
    padding-top: 40px;
    padding-left: 30px;
    padding-right: 10px;
}
span{
    display: inline-block;
    margin-top: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/phone.vue